import { Component } from "react"
import PropTypes from "prop-types"
import { factorFormatter, percentageFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"
import "../../style.scss"

class RiskFactor extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    exposure: PropTypes.number,
    volatility: PropTypes.number,
    max: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    formatter: PropTypes.func.isRequired,
    category: PropTypes.string,
    openFactorProfile: PropTypes.func.isRequired,
    displayVolatility: PropTypes.bool.isRequired,
    isAggregated: PropTypes.bool,
  }

  onClick = () => {
    const { id, openFactorProfile } = this.props
    openFactorProfile(id)
  }

  render() {
    const { id, label, value, formatter, max, category, color, volatility, exposure, displayVolatility, isAggregated } = this.props
    const link = id === "other" || getFactorDisabled(category) || isAggregated
      ? <div className="display">{label}</div>
      : <a className="display" onClick={this.onClick}>{label}</a>

    const chartWidth = Math.abs(value) / max * 100
    return <div className="factor">
      {link}
      <div className="value">
        <div className="bar-chart" style={{ width: `${chartWidth}%`, backgroundColor: color }}>
          <span>{chartWidth > 14 && formatter(value)}</span>
        </div>
        {chartWidth <= 14 && <div className="small-value">{formatter(value)}</div>}
      </div>
      <div className="exposure">{factorFormatter(exposure)}</div>
      {displayVolatility && <div className="volatility">{percentageFormatter(volatility)}</div>}
    </div>
  }
}

export default RiskFactor
